import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
    const { user, isAdmin, authLoading } = UserAuth();
    const location = useLocation();

    if (authLoading) {
        return null;
    }

    if (!user || !isAdmin) {
        return <Navigate to='/' />;
    } else if (!user.emailVerified) {
        return <Navigate to="/signup" replace state={{ returnTo: location.pathname + location.search }} />;
    } else {
        return children;
    }
};

export default AdminRoute;
